import * as React from "react"

export class Map extends React.Component {
  render() {
    return (
      <iframe
        title="map"
        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2519.2189918339714!2d5.683628616490155!3d50.84562887953196!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47c0e9b08ff58003%3A0x3c7413417ef5ef47!2sStudenten%20Rechtsbureau%20Maastricht!5e0!3m2!1sen!2snl!4v1632413943394!5m2!1sen!2snl"
        allowFullScreen={true}
        className="w-full rounded-xl shadow-sm h-80 border-2 border-white"
        loading="lazy"
      ></iframe>
    )
  }
}
